import React from "react";
import { useForm, FormProvider } from "react-hook-form";
import PVMain from "./Main";
import { PVContextProvider } from "./PV.Context";
import { PVProvider } from "../PV3/PressureVesselData/PVContext";

export default function PVModeling() {
  const methods = useForm();

  return (
    <FormProvider {...methods}>
      <PVProvider>
        <PVContextProvider>
          <PVMain />
        </PVContextProvider>
      </PVProvider>
    </FormProvider>
  );
}
